module.exports = __webpack_public_path__ + "static/Group_6272_2x-4fdbbd45ae404323b301dba7ea43ecd8.png";